import type { RouteObject } from 'react-router';

/** 014 US3: `/account` sits behind the session guard like every screen; there is no admin variant. */
export const routes: RouteObject[] = [
  { index: true, lazy: async () => ({ Component: (await import('./account-page')).default }) },
];
